// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","nav-links":"Navbar_nav-links__GbuXd","name":"Navbar_name__WeWN1","logo":"Navbar_logo__MK0b0","opt1":"Navbar_opt1__-2E46"};